module.exports = __webpack_public_path__ + "static/media/a.a5de86cb.jpg";